@switch (currentSettings) {
    @case (settingEnum.MAIN) {
        <web-widget-breadcrumbs [widget]="widget" [isInSpecificSection]="isSpecific" />
        <div class="panel-options-body overflow-wrapper">
            <p class="text-muted mb-20">{{ "shop_cart_prompt_text" | translate }}</p>
            <div class="form-group form-horizontal row mb-20">
                <label class="control-label col-xs-9">
                    {{ "mini_cart_enabled_label" | translate }}
                    <small
                        class="sp-icon icon-info-bold color-light"
                        [tooltip]="'mini_cart_enabled_tooltip' | translate"
                    ></small>
                </label>
                <div class="col-xs-3 control-switch text-right">
                    <sp-switch [active]="miniCartEnabled" (toggleActiveEvent)="toggleMiniCartEnabled($event)" />
                </div>
            </div>
            <div class="form-group mb-20">
                <label>
                    {{ "shop_cart_view" | translate }}
                </label>
                <div>
                    <a class="dotted" (click)="setCurrentSettingsType(settingEnum.CART_STYLE)">
                        {{ "shop_cart_style" | translate }}
                    </a>
                </div>
                <!--                <div class="appearance-wrapper mb-10">-->
                <!--                    <div-->
                <!--                        class="appearance-block"-->
                <!--                        [class.active]="cartViewType.value === cartViewStyleType.HORIZONTAL"-->
                <!--                        (click)="onSwitchCartViewType(cartViewStyleType.HORIZONTAL)">-->
                <!--                        <img [src]="'./assets/img/websites/lpc-cart-view-h-icon.svg'" [alt]="'Horizontal'">-->
                <!--                    </div>-->
                <!--                    <div-->
                <!--                        class="appearance-block"-->
                <!--                        [class.active]="cartViewType.value === cartViewStyleType.VERTICAL"-->
                <!--                        (click)="onSwitchCartViewType(cartViewStyleType.VERTICAL)">-->
                <!--                        <img [src]="'./assets/img/websites/lpc-cart-view-v-icon.svg'" [alt]="'Vertical'">-->
                <!--                    </div>-->
                <!--                </div>-->
                <div>
                    <a class="dotted" (click)="setCurrentSettingsType(settingEnum.CART_ICON_STYLE)">
                        {{ "shop_cart_icon_style" | translate }}
                    </a>
                </div>
                @if (miniCartEnabled) {
                    <a class="dotted" (click)="setCurrentSettingsType(settingEnum.MINI_CART)">
                        {{ "mini_cart_settings" | translate }}
                    </a>
                }
            </div>
            <hr class="panel-options-divider" />
            @if (showNonCustomPaymentRestriction) {
                <div class="alert alert-paid has-paid-badge plan-standard">
                    <span class="badge badge-paid plan-standard">&nbsp;</span>

                    {{ "shop_cart_non_custom_payment_restriction" | translate }}&#46;

                    <a href="/landing-pages/plans/" target="_blank">
                        {{ "change_tariff_link" | translate }}
                        <small class="sp-icon icon-outgoing small-xs"></small>
                    </a>
                </div>
            }
            <div class="form-group mb-20">
                <web-payment-methods-collection
                    [paymentMethods]="paymentMethods()"
                    [isShopCart]="true"
                    [isLoading]="paymentMethodsQuery.isPending()"
                    [isFailure]="paymentMethodsQuery.isError()"
                    [paymentElements]="paymentElements"
                    (editActionEvent)="editPaymentElement($event)"
                    (setSkipHistoryEvent)="setSkipHistory()"
                    (setPaymentElementsEvent)="setPaymentElements($event)"
                />
            </div>
            <p class="text-muted mb-20">{{ "form_prompt_text" | translate }}</p>
            @if (isCrmDisabled()) {
                <div class="alert alert-warning">
                    <a href="/crm/deals" target="_blank"
                        >{{ "crm_not_initialized_link" | translate }}
                        <img class="font-icon" src="./assets/img/websites/lpc-new-window-icon.svg"
                    /></a>
                    {{ "crm_not_initialized_text" | translate }}
                </div>
            } @else {
                @if (createContactAndDeal.value) {
                    <div class="form-group mb-20" [class.has-error]="dealName.invalid">
                        <label>
                            {{ "crm_deal_name" | translate }}
                        </label>
                        <input class="form-control" type="text" [formControl]="dealName" />
                        @if (dealName.invalid) {
                            <span class="help-block small">
                                {{ "control_errors_required" | translate }}
                            </span>
                        }
                    </div>
                    <web-crm-pipelines-collection
                        [selectedPipeline]="selectedPipeline.value"
                        [selectedPipelineStep]="selectedPipelineStep.value"
                        [isCrmDisabled]="isCrmDisabled()"
                        [crmPipelines]="crmPipelines()"
                        [isLoading]="crmPipelinesQuery.isLoading()"
                        [isError]="crmPipelinesQuery.isError()"
                        (setSkipHistoryEvent)="setSkipHistory()"
                        (selectedPipelineChange)="setPipeline($event.pipeline, $event.step, $event.settings)"
                        (selectedPipelineNameChange)="setPipelineName($event)"
                    />
                }
                <div class="mb-10">
                    <div class="form-group form-horizontal row mb-10">
                        <label class="control-label col-xs-9">
                            {{ "add_tags_crm" | translate }}
                        </label>
                        <div class="col-xs-3 control-switch text-right">
                            <sp-switch [active]="addCrmTags.value" (toggleActiveEvent)="toggleAddCrmTags($event)" />
                        </div>
                    </div>
                    @if (addCrmTags.value) {
                        <web-tags-collection
                            [selected]="contactTags.value"
                            (selectedChange)="onContactTagsChange($event)"
                            [tags]="crmTags()"
                            [isLoading]="crmTagsQuery.isPending()"
                            [isError]="crmTagsQuery.isError()"
                        />
                    }
                </div>
                <div>
                    <div class="form-group form-horizontal row">
                        <label class="control-label col-xs-9">
                            {{ "add_address_book" | translate }}
                        </label>
                        <div class="col-xs-3 control-switch text-right">
                            <sp-switch
                                [active]="createAddressBook.value"
                                (toggleActiveEvent)="toggleAddressBookSettings($event)"
                            />
                        </div>
                    </div>
                    @if (createAddressBook.value) {
                        <sp-address-books-ui
                            [data]="addressBooksQuery.data() ?? []"
                            [isLoading]="addressBooksQuery.isPending()"
                            [isError]="addressBooksQuery.isError()"
                            [selected]="selectedAddressBook.value"
                            (selectedChange)="selectedAddressBook.patchValue($event)"
                            showContactHint
                        />
                    }
                </div>
                @if (createAddressBook.value && selectedAddressBook.value) {
                    <div class="well well-sm" style="margin-top: -15px">
                        <div class="form-group form-horizontal row mb-10">
                            <label class="control-label col-xs-9">
                                {{ "add_tags_address_book" | translate }}
                            </label>
                            <div class="col-xs-3 control-switch text-right">
                                <sp-switch
                                    [active]="addAddressBookTags.value"
                                    (toggleActiveEvent)="toggleAddAddressBookTags($event)"
                                ></sp-switch>
                            </div>
                        </div>

                        @if (addAddressBookTags.value) {
                            <web-tags-collection
                                [selected]="contactAddressBookTags.value"
                                (selectedChange)="onContactAddressBookTagsChange($event)"
                                [tags]="addressBooksTags()"
                                [isLoading]="addressBooksTagsQuery.isPending()"
                                [isError]="addressBooksTagsQuery.isError()"
                            />
                        }
                    </div>
                }
            }
            <hr class="panel-options-divider" />
            <div class="mb-20" cdkDropList [cdkDropListData]="elements" (cdkDropListDropped)="dropElementItem($event)">
                <label>
                    {{ "control_form_fields" | translate }}
                </label>
                <a class="dotted pull-right" (click)="setCurrentSettingsType(settingEnum.INPUT)">
                    {{ "control_form_fields_styles" | translate }}
                </a>
                @for (input of elements.value; track trackByElementIndex(i); let i = $index) {
                    <div cdkDrag cdkDropListGroup [cdkDragData]="input">
                        <sp-control-handle
                            controlHandleBtn
                            [controlHandleDisableDelete]="elements.controls.length === 1 || isDisabledDelete(input)"
                            [controlHandleIcon]="getControlHandleIcon(input.type)"
                            [controlHandleMainText]="input.label | spHtmlToText"
                            (removeActionEvent)="removeInput(i)"
                            (editActionEvent)="editInput(i)"
                        >
                            <span cdkDragHandle></span>
                            <ng-template #variablesTemplate>
                                <sp-variables-popover
                                    [element]="$any(input)"
                                    [addressBookVariablesList]="addressBookVariablesById(selectedAddressBook.value)"
                                    [crmContactsVariablesList]="crmContacts()"
                                    [crmDealsVariablesList]="crmDeals()"
                                    [createAddressBook]="createAddressBook.value"
                                />
                            </ng-template>
                        </sp-control-handle>
                    </div>
                }
                <a class="dotted" (click)="addInput()">{{ "add" | translate }}</a>
            </div>
            <div class="mb-20">
                <label>
                    {{ "form_button" | translate }}
                </label>
                <sp-control-handle
                    [controlHandleMainText]="label.value"
                    (editActionEvent)="setCurrentSettingsType(settingEnum.BUTTON)"
                />
            </div>

            @if (miniCartEnabled) {
                <div class="mb-20">
                    <label>
                        {{ "mini_cart_button_label" | translate }}
                    </label>
                    <sp-control-handle
                        [controlHandleMainText]="miniCartButtonLabel.value"
                        (editActionEvent)="setCurrentSettingsType(settingEnum.MINI_CART_BUTTON)"
                    />
                </div>
            }
            <!-- <div class="mb-20">
<div class="form-group form-horizontal row">
  <label class="control-label col-xs-6">
    {{ 'control_align_content' | translate }}
  </label>
  <div class="col-xs-6">
    <sp-radio-group
      [selected]="inputSettingsHorizontalPosition.value"
      [type]="radioGroupType.horizontalPosition"
      (changeSelectedEvent)="setInputSettingsHorizontalPosition($event)"
    ></sp-radio-group>
  </div>
</div>
</div> -->
            <div class="mb-20">
                <a class="dotted" (click)="setCurrentSettingsType(settingEnum.ADDITIONAL)">
                    {{ "additional_form_settings" | translate }}
                </a>
            </div>
            <div>
                <a class="dotted" (click)="setCurrentSettingsType(settingEnum.ANALYTICS)">
                    {{ "analytics_form_settings" | translate }}
                </a>
            </div>
            <div class="mt-20">
                <web-custom-id [displayId]="displayId" (valueChangeEvent)="updateWidgetDisplayId($event)">
                </web-custom-id>
            </div>
        </div>
    }
    @case (settingEnum.BUTTON) {
        <web-shop-cart-form-button-settings
            [itemForm]="formButtonSettings"
            (cancelEvent)="setCurrentSettingsType(settingEnum.MAIN)"
        />
    }
    @case (settingEnum.ELEMENT) {
        <web-shop-cart-form-element-settings
            [itemForm]="elements.at(editedInputIndex)"
            [elements]="elements.getRawValue()"
            [crmPipelinesList]="crmPipelines()"
            [addressBookVariablesList]="addressBookVariablesById(selectedAddressBook.value)"
            [crmContactsVariablesList]="crmContacts()"
            [crmDealsVariablesList]="crmDeals()"
            [isMainField]="editedInputIndex === 0"
            [isAddressBookListDisabled]="!createAddressBook.value"
            (cancelEvent)="setCurrentSettingsType(settingEnum.MAIN)"
        />
    }
    @case (settingEnum.INPUT) {
        <web-shop-cart-form-input-settings
            [widget]="widget"
            [itemForm]="inputSettings"
            (cancelEvent)="setCurrentSettingsType(settingEnum.MAIN)"
        />
    }
    @case (settingEnum.ADDITIONAL) {
        <web-shop-cart-form-additional-settings
            [isHasSuccessPageOption]="isHasSuccessPage()"
            [itemForm]="additionalFormSettings"
            (cancelEvent)="setCurrentSettingsType(settingEnum.MAIN)"
        />
    }
    @case (settingEnum.PAYMENT) {
        <web-shop-cart-form-payment-method-settings
            [itemForm]="paymentElements.at(editingPaymentIndex)"
            [paymentMethods]="paymentMethods()"
            [paymentElements]="paymentElements"
            (cancelEvent)="setCurrentSettingsType(settingEnum.MAIN)"
        />
    }
    @case (settingEnum.CART_STYLE) {
        <web-shop-cart-style-settings
            [itemForm]="cartSettings"
            (cancelEvent)="setCurrentSettingsType(settingEnum.MAIN)"
        />
    }
    @case (settingEnum.CART_ICON_STYLE) {
        <web-shop-cart-icon-settings
            [itemForm]="cartIconSettings"
            (cancelEvent)="setCurrentSettingsType(settingEnum.MAIN)"
        />
    }
    @case (settingEnum.ANALYTICS) {
        <web-analytics-settings
            (cancelEvent)="setCurrentSettingsType(settingEnum.MAIN)"
            [itemForm]="analyticsSettings"
            [pixelAnalyticType]="pixelTypes.initiateCheckout"
            [isShopCart]="true"
        />
    }
    @case (settingEnum.MINI_CART) {
        <web-shop-cart-mini-cart-settings
            [itemForm]="miniCartSettings"
            [data]="widgetData"
            [classes]="classes"
            (cancelEvent)="setCurrentSettingsType(settingEnum.MAIN)"
        />
    }
    @case (settingEnum.MINI_CART_BUTTON) {
        <web-shop-cart-form-button-settings
            [itemForm]="miniCartButtonSettings"
            (cancelEvent)="setCurrentSettingsType(settingEnum.MAIN)"
        />
    }
}
